<style scoped>
	.c-t-body {
		border: 1px solid rgba(226, 226, 226, .6);
		border-bottom: none;
	}

	.c-t-head {
		display: flex;
	}

	.c-t-body>.row {
		display: flex;
		justify-content: center;
		align-items: center;
		border-bottom: 1px solid rgba(226, 226, 226, 1);
	}

	.c-t-head>.col {
		height: 40px;
		background: rgba(244, 245, 247, 1);
		line-height: 40px;
		font-size: 14px;
	}

	.c-t-body>.row>.col {
		min-height: 40px;
		font-size: 14px;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.red-color {
		color: red;
	}

	.row .goods-detail {
		display: inline-flex;
		align-items: center;
		width: 80%;
		padding: 10px;
	}

	.row .goods-detail>.head-img {
		width: 80px;
		height: 80px;
	}

	.row .goods-detail>.detail {
		text-align: left;
		margin-left: 15px;
	}

	.row .goods-detail>.detail>.goods-info:nth-child(1) {
		padding: 5px 0 5px 0 !important;
	}

	.row .goods-detail>.detail>.goods-info:nth-child(n + 2) {
		line-height: 20px;
		color: #666666;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.pay {
		background-image: linear-gradient(#3f9fea, #0a77ce);
		color: #fff;
	}
</style>

<template>
	<SecondaryPageComponent :type-list="$t('tab.Collection')" :type-change-event="typeChange" :total-data-counts="totalDataCounts"
	 :page-size="pageSize">
		<!-- 收藏列表表格   内容插槽 插槽内容 -->
		<div class="collection-table" slot="content-slot">
			<div class="c-t-head">
				<div v-for="item in thead" class="col" :class="item.width + ' ' + item.align">{{item.title}}</div>
			</div>
			<div class="c-t-body">
				<div class="row" v-if="dataList.length <= 0"><span class="none-data">{{$t('vip.available')}}...</span></div>
				<div v-if="dataList.length > 0" class="row" v-for="(outItem,outIndex) in dataList">
					<div v-for="(item,index) in thead" class="col" :class="item.width + ' ' + item.align">
						<!--col 1-->
						<template v-if="index === 0">
							<div class="goods-detail">
								<img class="head-img" :src="outItem.params.productImg.split(',')[0]" />
								<div class="detail">
									<p class="goods-info">{{outItem.params.productName}}</p>
									<p class="goods-info">{{$t('search.model')}}：{{outItem.params.productNum}}</p>
									<p class="goods-info">{{$t('search.describe')}}：
										{{outItem.params.productDescribe}}
									</p>
								</div>
							</div>
						</template>
						<!--col 2-->
						<template v-if="index === 1"><span class="red-color">${{(outItem.params.unitPrice / 100).toFixed(2)}}</span>
						</template>
						<!--col 3-->
						<template v-if="index === 2">
							<div class="btn-col">
								<a class="btn pay" href="javascript:void(0)" @click="settlementToPay(outItem.params.productId)">{{$t('shopDet.purchase')}}</a>
								<a class="btn" href="javascript:void(0)" @click="addtocart(outItem.params.productId)">{{$t('shopDet.shoppingCart')}}</a>
								<a class="btn" href="javascript:void(0)" @click="cancel(outIndex)">{{$t('shopDet.cancel')}}</a>
							</div>
						</template>
					</div>
				</div>
			</div>
		</div>
		<!-- page 分页 插槽内容 -->
		<div class="page-component" slot="pager-slot">
			<el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"
			 :total="totalDataCounts">
			</el-pagination>
		</div>
	</SecondaryPageComponent>
</template>

<script>
	import '../../../assets/css/l-table.css';
	import SecondaryPageComponent from '../../assembly/SecondaryPageComponent';

	export default {
		name: 'collectionAll',
		components: {
			SecondaryPageComponent
		},
		data() {
			return {
				thead: [],
				pageSize: 5,
				totalDataCounts: 0,
				pageNum: 1,
				currentPage: 1,
				dataList: [],
				token: ''
			};
		},
		created() {
			this.thead = this.$t('search.thead')
			this.token = sessionStorage.getItem('token');
			this.loadData(1);
		},
		methods: {
			// 立即购买
			settlementToPay(carIds) {
				//跳转提交订单页面
				this.$router.push({
					path: '/submit/order',
					query: {
						carIds,
						num: 1,
						number:1
					}
				});
			},
			// 加入购物车
			addtocart(proCollecId) {
				let url = '/api/shop/car/add'
				let data = {
					producNum: 1,
					productId: proCollecId,
					token: sessionStorage.getItem('token')
				}
				this.$post(url, data).then(res => {
					if (res.code == 0) {
						this.$message({
							showClose: true,
							message: this.$t('Tips.addsuc'),
							type: 'success'
						});
					}

				})
			},
			//页码改变的时候
			handleCurrentChange(pageNum) {
				this.currentPage = pageNum;
				this.pageNum = pageNum;
				this.loadData(pageNum);
			},
			//类型改变的时候
			typeChange(index) {
				this.currentPage = 1;
				this.loadData(1);
			},
			//立即购买 ， 跳转商品详情
			buy(i) {

			},
			//取消收藏
			cancel(i) {
				this.$confirm(this.$t('Tips.sccancel'), this.$t('Tips.Tips')).then(res => {
					this.$post('api/productCollection/deleteProductCollection', {
						proCollecId: this.dataList[i].proCollecId,
						token: this.token
					}).then(res => {
						if (res.code === 0) {
							this.loadData(this.pageNum);
						}
					});
				})
			},
			//加载数据
			loadData(pageNum) {
				this.$get('api/productCollection/getProductCollectionAll', {
					pageNum,
					pageSize: this.pageSize,
					token: this.token
				}).then(res => {
					this.dataList = res.data;
					this.totalDataCounts = res.params.totalDataCounts;
				})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/memberCenter/collection/CollectionAll.vue